import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import SchemaFieldSelectorStore from 'registry/schema-field-selector/SchemaFieldSelectorStore';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';

export default class SchemaFieldSelectorModelManager extends ModelManager<ManagedModelType.SCHEMA_FIELD_SELECTOR_BY_ID> {
  constructor() {
    super(ManagedModelType.SCHEMA_FIELD_SELECTOR_BY_ID);
  }

  async doFetchMulti(selectorIds: Array<string>): Promise<void> {
    const SchemaFieldSelectorActions =
      // Inline the import to avoid circular dependency on filestates.
      require('registry/schema-field-selector/SchemaFieldSelectorActions').default;
    await SchemaFieldSelectorActions.fetch();
  }

  getModel(selectorId: string): SchemaFieldSelector | null {
    return SchemaFieldSelectorStore.getSelectorById(selectorId);
  }
}
